(() => {
  const colors = { black: ['Black', '#09090a'], white: ['White', '#ffffff'], red: ['Red', '#e74132'], green: ['Green', '#167548'], blue: ['Blue', '#4157ff'], yellow: ['Yellow', '#f2c600'] };
  const cartKey = 'rollmylogo-demo-cart';
  document.querySelectorAll('[data-rml-markers]').forEach(root => {
    let submitting = false;
    const cards = [...root.querySelectorAll('[data-marker-form]')].map(form => ({
      form, color: Object.hasOwn(colors, form.dataset.markerColor) ? colors[form.dataset.markerColor] : null, demo: form.hasAttribute('data-marker-demo'),
      quantity: form.querySelector('[data-marker-quantity]'), add: form.querySelector('[data-marker-add]'),
      status: form.querySelector('[data-marker-status]'), variant: form.querySelector('[data-marker-variant]'),
      ink: form.querySelector('[data-marker-ink]'),
    }));
    const picker = document.createElement('fieldset'); picker.className = 'rml-markers__picker';
    const legend = document.createElement('legend'); legend.textContent = 'Ink color';
    const choices = document.createElement('div'); choices.className = 'rml-markers__choices';
    choices.setAttribute('role', 'radiogroup'); choices.setAttribute('aria-label', 'Ink color');
    picker.append(legend, choices);
    let selectedCard = cards.find(card => card.color);
    const selectColor = (card, focus = false) => {
      if (submitting || !card.color) return;
      selectedCard = card;
      cards.forEach(item => {
        const selected = item === card;
        item.form.dataset.markerSelected = String(selected);
        if (item.choice) { item.choice.setAttribute('aria-checked', String(selected)); item.choice.tabIndex = selected ? 0 : -1; }
      });
      // Keep each color's original price, inventory, quantity and Shopify form together.
      card.form.querySelector('.rml-markers__color').after(picker);
      if (focus) card.choice.focus({ preventScroll: true });
    };
    cards.filter(card => card.color).forEach(card => {
      const choice = document.createElement('button'); choice.type = 'button'; choice.className = 'rml-markers__choice';
      choice.setAttribute('role', 'radio'); choice.setAttribute('aria-label', `${card.color[0]} ink`);
      choice.title = `${card.color[0]} ink`; choice.style.setProperty('--marker-option', card.color[1]);
      choice.addEventListener('click', () => selectColor(card, true));
      card.choice = choice; choices.append(choice);
    });
    choices.addEventListener('keydown', event => {
      if (!['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const options = cards.filter(card => card.color), index = options.indexOf(selectedCard);
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1
        : (index + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + options.length) % options.length;
      selectColor(options[next], true);
    });
    if (selectedCard) { selectColor(selectedCard); root.classList.add('rml-markers--single-mobile'); }
    const stockLimit = card => /^\d+$/.test(card.form.dataset.stockLimit || '') ? Math.min(99, Number(card.form.dataset.stockLimit)) : 99;
    const available = card => !!card.color && (card.demo || (card.form.dataset.available === 'true' && /^\d+$/.test(card.variant.value) && stockLimit(card) > 0));
    const update = () => cards.forEach(card => {
      card.add.disabled = submitting || !available(card);
      card.quantity.max = String(card.demo ? 99 : Math.max(1, stockLimit(card)));
      if (card.choice) card.choice.disabled = submitting;
    });
    cards.forEach(card => card.form.addEventListener('submit', event => {
      if (card.demo) event.preventDefault();
      if (submitting || !available(card)) { event.preventDefault(); return; }
      const quantity = Number(card.quantity.value);
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > 99) {
        event.preventDefault(); card.status.textContent = 'Choose a quantity between 1 and 99.'; card.quantity.focus(); return;
      }
      if (!card.demo && quantity > stockLimit(card)) {
        event.preventDefault(); card.status.textContent = `Only ${stockLimit(card)} available.`; card.quantity.focus(); return;
      }
      card.ink.value = card.color[0];
      if (!card.demo) { submitting = true; update(); return; }
      try {
        const cart = JSON.parse(localStorage.getItem(cartKey) || '[]');
        if (!Array.isArray(cart)) throw new Error('Invalid cart');
        cart.push({ kind: 'marker', id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
          title: `Extra marker: ${card.color[0]}`, ink: card.color[1], quantity, surface: '#eff1f2' });
        localStorage.setItem(cartKey, JSON.stringify(cart));
        submitting = true; update();
        document.dispatchEvent(new CustomEvent('rollmylogo:cart-updated'));
        location.assign('cart.html');
      } catch (_error) {
        submitting = false; update();
        card.status.textContent = 'Could not save this item. Please check browser storage and try again.';
      }
    }));
    window.addEventListener('pageshow', () => { submitting = false; update(); });
    update();
  });
})();
